var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 18.21 16.62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 16.62c-.14 0-.28-.06-.38-.16L1.39 8.6C.49 7.63 0 6.36 0 5.04c0-1.32.49-2.59 1.39-3.55a4.556 4.556 0 016.73-.01l.97 1.05.98-1.04a4.57 4.57 0 016.74 0c.9.97 1.39 2.24 1.39 3.56 0 1.32-.49 2.59-1.39 3.55l-3.56 3.81-.11.12-3.67 3.93c-.1.1-.23.16-.38.16zM4.76 1.02c-1 0-1.94.44-2.61 1.18a4.235 4.235 0 000 5.7l6.95 7.45c1.16-1.25 2.34-2.51 3.48-3.73l.02-.02c1.15-1.23 2.3-2.47 3.46-3.7a4.222 4.222 0 000-5.69 3.468 3.468 0 00-5.21 0L9.5 3.65a.51.51 0 01-.73.02l-.02-.02L7.39 2.2a3.564 3.564 0 00-2.61-1.18z",
    fill: "#ea6c68"
  })));
};

export default SvgHeart;